import { generateMinutesPreview } from '../services/online/calendar/calendar';
import { arrayBufferToBase64 } from './arrayBuffer.web';
export async function downloadFile(url) {
    if (!url || url === '')
        return;
    const link = document.createElement('a');
    let newUrl = url;
    const resp = await fetch(url)
        .then(async (elt) => await elt.blob())
        .catch(e => console.log('Fail to fetch ressource because:', e));
    if (resp) {
        newUrl = URL.createObjectURL(resp);
        const filename = url.split('/')[url.split('/').length - 1].split('?')[0];
        link.setAttribute('download', filename);
    }
    link.href = newUrl;
    link.target = '_blank';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}
export async function downloadFileWithRename(url, filename) {
    if (!url || url === '')
        return;
    const link = document.createElement('a');
    let newUrl = url;
    const resp = await fetch(url)
        .then(async (elt) => await elt.blob())
        .catch(e => console.log('Fail to fetch ressource because:', e));
    if (resp) {
        newUrl = URL.createObjectURL(resp);
        link.setAttribute('download', filename);
    }
    link.href = newUrl;
    link.target = '_blank';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}
export async function downloadMinutes(eventId, culture) {
    const fileUrl = await generateMinutesPreview(eventId, {
        culture,
    });
    await downloadFile(fileUrl);
}
export async function downloadFileToPDF(fileName, pdftronWebviewerInstance, withAnnotations, watermark) {
    try {
        const xfdfString = await pdftronWebviewerInstance.Core.documentViewer
            .getAnnotationManager()
            .exportAnnotations();
        if (watermark) {
            // Add watermark into the document
            await pdftronWebviewerInstance.Core.documentViewer.setWatermark({
                diagonal: {
                    fontSize: 40,
                    fontFamily: 'sans-serif',
                    color: '#00a0df',
                    opacity: 15,
                    text: watermark,
                },
            });
            // Download pdf with watermark
            await pdftronWebviewerInstance.UI.downloadPdf({
                filename: fileName,
                includeAnnotations: withAnnotations,
                xfdfString,
            });
            // Remove the watermark from the document
            await pdftronWebviewerInstance.Core.documentViewer.setWatermark({
                diagonal: {
                    text: null,
                },
            });
            return;
        }
        await pdftronWebviewerInstance.UI.downloadPdf({
            filename: fileName,
            includeAnnotations: withAnnotations,
            xfdfString,
        });
    }
    catch (error) {
        console.error('Erreur lors du téléchargement du fichier PDF :', error);
    }
}
export async function convertToPDFForSigners(pdftronWebviewerInstance, documentUri, documentFileName, resolveSigners) {
    try {
        const { officeToPDFBuffer } = pdftronWebviewerInstance.Core;
        // Extract extension from filename
        const extension = documentFileName.includes('.') ? documentFileName.split('.').pop() : 'pdf';
        // download in array buffer
        const originalFile = await fetch(documentUri).then(res => res.arrayBuffer());
        // Convert to PDF using the document URI
        const docBuffer = await officeToPDFBuffer(originalFile, {
            extension: extension,
        });
        // Create the converted file object
        const convertedFile = {
            content: arrayBufferToBase64(docBuffer),
            filename: `${documentFileName}.pdf`,
            mimeType: 'application/pdf',
            thumbnailUri: '',
            uri: '',
        };
        // Call the resolver with the converted file
        await resolveSigners(convertedFile);
    }
    catch (error) {
        console.error('Erreur lors de la conversion en PDF pour les signataires :', error);
        // Call the resolver without file in case of error
        await resolveSigners();
    }
}
